<template>
  <div class="locale-switcher">
    <select :value="current" aria-label="Language" @change="onChange">
      <option v-for="item in locales" :key="item.code" :value="item.code">
        {{ item.label }}
      </option>
    </select>
  </div>
</template>

<script>
import { ENABLED_LOCALES, setLocale } from '@/i18n'

export default {
  name: "LocaleSwitcher",
  data() {
    return {
      locales: ENABLED_LOCALES
    };
  },
  computed: {
    current() {
      return this.$i18n.locale;
    }
  },
  methods: {
    onChange(event) {
      setLocale(event.target.value);
    }
  }
};
</script>

<style lang="less" scoped>
.locale-switcher {
  display: inline-flex;
  align-items: center;
  select {
    height: 30px;
    padding: 0 22px 0 8px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    background: #fff;
    color: #51565d;
    font-size: 13px;
    outline: none;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LocaleSwitcher.vue